import "./index.css"
import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';

export default function RankingItem(props) {
    const theme = useTheme();

    let audio = new Audio(props.musicSrc);
    const start = () => {
        audio.play();
    }
    const stop = () => {
        audio.pause();
    }


    return (
        <Card sx={{ display: 'flex', margin: '20px'}}>
            <CardMedia
                component="img"
                sx={{ width: 151 }}
                image={props.imgSrc}
                alt="Live from space album cover"
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', ml: '20px'}}>
                <CardContent sx={{ flex: '1 0 auto' }}>
                    <Typography component="div" variant="h5">
                        {props.musicName}
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary" component="div">
                        {props.creator}
                    </Typography>
                </CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
                    <IconButton aria-label="previous">
                        {theme.direction === 'rtl' ? <SkipNextIcon /> : <SkipPreviousIcon />}
                    </IconButton>
                    <IconButton aria-label="play/pause" onClick={start}>
                        <PlayArrowIcon sx={{ height: 38, width: 38 }} />
                    </IconButton>
                    <IconButton aria-label="play/pause" onClick={stop}>
                        <PauseCircleIcon sx={{ height: 38, width: 38 }} />
                    </IconButton>
                    <IconButton aria-label="next">
                        {theme.direction === 'rtl' ? <SkipPreviousIcon /> : <SkipNextIcon />}
                    </IconButton>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', ml: '50px'}}>
                <Typography component="div" variant="h5" className="token-text" mt="50px">
                    {props.token}
                </Typography>
            </Box>

        </Card>
    )
}